export default "__VITE_ASSET__CCPy70Yr__"